// docs/plan/v0.5.0-telemetry-supplier-inventory-predictive/plan.md §4.5
// Supplier read + write endpoints.

import type { SupplierCategory, SupplierSummaryDto } from '@bhops/shared';
import { apiClient } from './client';

export interface ListSuppliersQuery {
  category?: SupplierCategory;
  active?: boolean;
  search?: string;
}

export interface CreateSupplierBody {
  code: string;
  displayName: string;
  contactEmail?: string;
  contactPhone?: string;
  category?: SupplierCategory;
  active?: boolean;
}

export interface UpdateSupplierBody {
  displayName?: string;
  contactEmail?: string | null;
  contactPhone?: string | null;
  category?: SupplierCategory | null;
  active?: boolean;
}

export const suppliersApi = {
  async list(query: ListSuppliersQuery = {}): Promise<SupplierSummaryDto[]> {
    const { data } = await apiClient.get<SupplierSummaryDto[]>('/suppliers', {
      params: query,
    });
    return data;
  },
  async get(id: string): Promise<SupplierSummaryDto> {
    const { data } = await apiClient.get<SupplierSummaryDto>(`/suppliers/${id}`);
    return data;
  },
  async create(body: CreateSupplierBody): Promise<SupplierSummaryDto> {
    const { data } = await apiClient.post<SupplierSummaryDto>('/suppliers', body);
    return data;
  },
  async update(id: string, body: UpdateSupplierBody): Promise<SupplierSummaryDto> {
    const { data } = await apiClient.patch<SupplierSummaryDto>(`/suppliers/${id}`, body);
    return data;
  },
};
